import React from 'react';
import formatServerErrors from '../helpers/formatServerErrors';
import Sanitise from '../components/utilities/Sanitise';

function processServerErrors(error, i18n) {
  let formErrors = {};
  let messages = new Set();

  if (error.response && error.response.status) {
    switch (error.response.status) {
      case 400:
        if (error.response.data && Array.isArray(error.response.data)) {
          // Set the server returned errors into the form state.
          formErrors = formatServerErrors(error.response.data, i18n);
        } else {
          if (error.response.data && error.response.data.message) {
            messages.add({ type: 'warning-alert', message: <Sanitise string={error.response.data.message} /> });
          } else {
            messages.add({
              type: 'warning-alert',
              message: i18n.t('styleguide:messages.error' + error.response.status)
            });
          }
        }
        break;
      default:
        if (error.response.data && error.response.data.message) {
          messages.add({ type: 'warning-alert', message: <Sanitise string={error.response.data.message} /> });
        } else {
          messages.add({ type: 'warning-alert', message: i18n.t('styleguide:messages.error' + error.response.status) });
        }
        break;
    }
  } else {
    if (error.code === 'ERR_NETWORK') {
      messages.add({
        type: 'warning-alert',
        message: error.message ? <Sanitise string={error.message} /> : 'ERR_NETWORK'
      });
    }
    if (error.code === 'ERR_BAD_REQUEST') {
      messages.add({ type: 'warning-alert', message: <Sanitise string={error.message} /> });
    }
  }
  return {
    formErrors: formErrors,
    messages: messages,
    status: error.response && error.response.status ? error.response.status : null // @todo maybe not null?
  };
}

export default processServerErrors;
